var map = {
  "./en.json": [
    "74082",
    "3368"
  ],
  "./my.json": [
    "95287",
    "9049"
  ],
  "./th.json": [
    "47372",
    "2124"
  ],
  "./vn.json": [
    "57496",
    "4720"
  ],
  "./cn.json": [
    "77551",
    "1078"
  ],
  "./id.json": [
    "59484",
    "7682"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7810;
module.exports = webpackAsyncContext;
